import Icon from './Icon';
import './Icon.css';

export default Icon;



// WEBPACK FOOTER //
// ./src/shared/components/Icon/index.js